import { render, staticRenderFns } from "./DemoExerciseSuccessFeedbackComponent.vue?vue&type=template&id=a96c31dc&scoped=true&"
import script from "./DemoExerciseSuccessFeedbackComponent.vue?vue&type=script&lang=js&"
export * from "./DemoExerciseSuccessFeedbackComponent.vue?vue&type=script&lang=js&"
import style0 from "./DemoExerciseSuccessFeedbackComponent.vue?vue&type=style&index=0&id=a96c31dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c31dc",
  null
  
)

export default component.exports